import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  projectId: number,
 *  objectId: number,
 *  fieldCode: string,
 *  value: string }} verificationRequest
 */

/**
 * @typedef {{
 *  action: string,
 *  actionDate: string,
 *  actionBy: number,
 *  value: string }} verificationRequestResponse
 */

/**
 * @typedef {{
 *  id: number,
 *  municipalityId: number,
 *  municipalityName: string,
 *  treasurerName: string,
 *  isVerified: boolean,
 *  isEditRequested: boolean,
 *  contactName: string,
 *  contactEmail: string,
 *  contactPhone: string,
 *  institutionName: string,
 *  institutionNumber: string,
 *  transitNumber: string,
 *  accountNumber: string }} BankingInformationView
 * */

const api = new Api("api/amo/banking-information");

const municipalityApi = (municipalityId) =>
  new Api(`api/municipality/${municipalityId}/banking-information`);

/**
 * @param {verificationRequest} payload
 * @returns {Promise<AxiosResponse>} Empty response
 */
export const postRequestVerification = (payload) => {
  api.post("request-verification", payload);
};

/**
 * @returns {Promise<AxiosResponse<verificationRequestResponse>>} Empty response
 */
export const getRequestVerification = () => api.get("request-verification");

/**
 * @param {number} municipalityId
 * @returns {Promise<AxiosResponse<BankingInformationView>>}
 */
export const getBankingInformation = (municipalityId) =>
  municipalityApi(municipalityId).get();

/**
 * @param {number} municipalityId
 * @param {number} payload
 * @returns {Promise<AxiosResponse>}
 */
export const postBankingInformation = (municipalityId, payload) =>
  municipalityApi(municipalityId).post("", payload);

/**
 * @param {number} municipalityId
 * @param {number} payload
 * @returns {Promise<AxiosResponse>}
 */
export const postRequestToEdit = (municipalityId, payload) =>
  municipalityApi(municipalityId).post("request-edit", payload);

/**
 * @param {number} municipalityId
 * @returns {Promise<AxiosResponse>}
 */
export const putVerifyBankingInformation = (municipalityId) =>
  municipalityApi(municipalityId).putId("verify", {});

/**
 * @returns {Promise<AxiosResponse>}
 */
export const putExportedBankingInformation = () => api.put("exported");
